document.addEventListener("DOMContentLoaded", function () {
    // JW Player setup
    window.jwplayer.key = "a7FKx3kj2wUMh+SHQlcg3hkzAtCZf0erMYsHaue4B6w=";

    document.querySelectorAll(".video-player").forEach(el => {
        window.jwplayer(el.id).setup({
            base: '/dist/js/vendor/jwplayer',
            file: el.dataset.videoUrl,
            image: el.dataset.videoThumb,
            mediaid: el.dataset.videoId,
            title: el.dataset.videoTitle,
            width: "100%",
            aspectratio: "16:9",
            skin: {
                active: "#fff",
                background: "#254257",
                inactive: "#ffffff"
            }
        });
    });

    // Video overlay controls
    window.openVideo = function () {
        const overlay = document.getElementById('videoOverlay');
        if (overlay) {
            overlay.setAttribute('aria-hidden', 'false');
            overlay.classList.add('active');

            const video = overlay.querySelector('video');
            if (video) {
                video.play();
            }
        }
    };

    window.closeVideo = function () {
        const overlay = document.getElementById('videoOverlay');
        if (overlay) {
            overlay.setAttribute('aria-hidden', 'true');
            overlay.classList.remove('active');

            const video = overlay.querySelector('video');
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
        }
    };
});